import { IsArray, IsFunction } from "@pdfking/tfunc"
import { is_element } from "./is_element"
import { is_iterator } from "./is_iterator"

/**
 * Checks if value is a plain object mapping.
 *
 * True for plain objects, false for arrays, functions, iterators, and DOM elements.
 *
 * @param iterable - Value to check
 * @returns True if plain object mapping
 */
export const is_mapping = (
  iterable: unknown
): iterable is Record<string, unknown> =>
  // biome-ignore lint/style/noRestrictedGlobals: checking instanceof Object
  iterable instanceof Object &&
  !IsArray(iterable) &&
  !is_iterator(iterable) &&
  !IsFunction(iterable) &&
  !is_element(iterable)
